import React from 'react';
import styled from 'styled-components'
import ReactGA from 'react-ga';
import { FaLinkedinIn, FaInstagram, FaYelp } from "react-icons/fa";
import NavLinkList from './NavLinkList';


const Wrapper =  styled.div`
    display: flex;
    flex-direction: column;
    height: 15rem;
    width: 100%;

    /* @media(max-width: 500px) {
      height: 13rem;
    } */

  > * {
    margin: 0 10px;
    display: inline-block;
    margin-top: 0;
  }
`;

const MainFooter = styled.div`
    height: 13rem;
    margin: 0;
    background-color: #272727;
`;

const SubFooter = styled.div`
    height: 4rem;
    margin: 0;
    background-color: #4a4a4a;
`;

const FooterContentWrapper = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    > * {
      font-size: 13px;
      color: #fff;
    }

    p {
        margin: 0;
        padding-bottom: 15px;
        letter-spacing: 2px;
        font-size: 11px;
    }
`;

const SMIconsWrapper = styled.div`
    width: 230px;
    display: flex;
    padding-bottom: 0.75em;
    justify-content: space-evenly;
`;
// Social Media circle icon wrappers
const SMCircles = styled.div`
    width: 55px;
    height: 55px;
    border-radius: 50%;
    background-color: red;

    > * {
      position: absolute;
      color: #272727;
      font-size: 30px;
      vertical-align: middle;
      margin: 3px 12px;

      &:hover {
        color: #fff;
      }
    }
`;

const FooterLinksWrapper = styled.div`

    ul {
        display: inline-flex;
        padding: 0;

        div {
            padding: 10px 10px;

            a {
                color: #fff;
                text-transform: uppercase;
                letter-spacing: 1px;
                font-size: 11px;

                &:hover, &:active, &:focus {
                    text-decoration: none;
                    color: #fff;
                }
            }
        }
    }
`;

const clickedLinkedIn = () => {
    ReactGA.event({
        category: 'Social',
        action: 'Clicked LinkedIn Icon'
    });
}

const clickedInstagram = () => {
    ReactGA.event({
        category: 'Social',
        action: 'Clicked Instagram Icon'
    });
}

const clickedYelp = () => {
    ReactGA.event({
        category: 'Social',
        action: 'Clicked Yelp Icon'
    });
}


const Header = () => {
    return (
        <Wrapper>
            <MainFooter>
                <FooterContentWrapper>
                    <div>
                        <p>FOLLOW US</p>
                    </div>
                    <SMIconsWrapper>
                        <SMCircles>
                            <a href="https://www.linkedin.com/in/calmel-designs-5b89a68a"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="LinkedIn"
                                onClick={clickedLinkedIn}
                            >
                              <FaLinkedinIn />
                            </a>
                        </SMCircles>
                        <SMCircles>
                            <a href="https://instagram.com/calmel_designs?utm_source=ig_profile_share&igshid=d7pfbwz8zpkk"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Instagram"
                                onClick={clickedInstagram}
                            >
                              <FaInstagram />
                            </a>
                        </SMCircles>
                        <SMCircles>
                            <a href="https://www.yelp.com/biz/calmel-construction-designs-los-angeles"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Yelp"
                                onClick={clickedYelp}
                            >
                              <FaYelp />
                            </a>
                        </SMCircles>
                    </SMIconsWrapper>
                    <FooterLinksWrapper>
                        <NavLinkList links={[
                            {title: 'Home', path:'/'},
                            {title: 'About Us', path:'/about'},
                            {title: 'Projects', path:'/projects'},
                            {title: 'Contact', path:'/contact'}
                        ]}/>
                    </FooterLinksWrapper>
                </FooterContentWrapper>
            </MainFooter>
            <SubFooter>
                <FooterContentWrapper>
                    <div style={{padding: '10px 0 10px 0', letterSpacing: '1px'}}>
                       Property Measuring | Shop Drawings | 3D Rendering
                    </div>
                    <div style={{fontSize: '11px'}}>
                      Copyright © {new Date().getFullYear()} Calmel Designs. All rights reserved.
                    </div>
                </FooterContentWrapper>
            </SubFooter>
        </Wrapper>
    );
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/Footer.js